import axios from '../request/http';
import {toFormData} from '../common/descriptions'

const order = {


// 获取快递公司列表
courierList(params) {
    return axios.get("/admin/order/courier/list", {params});
},
    // 平台商品订单列表
    managementGoodsList(params) {
        return axios.get("/admin/order/goods/list", {params});
    },
 
    // 商品详情
    managementGoodsDetail(params) {
        return axios.get("/admin/order/goods/detail", {params});
    },
    // 订单发货
    orderExpress(params) {
        return axios.get("/admin/order/send", {params});
    },
    // 待发货订单导出
    adminGoodsOrderExport(params) {
        return axios.get("/admin/order/list/download", {params,responseType:'arraybuffer'});
    },
    // 待发货订单导入
    adminGoodsExport(data) {
        return axios.post("/admin/order/uploadModel", data);
    },
//    获取售后订单列表
afterList(params) {
    return axios.get("/admin/order/goods/after-list", {params});
},
closeProduct(params){
    return axios.get("/admin/order/goods/after-end", {params});
},
// 获取售后订单详情、
productDetail(params){
    return axios.get("/admin/order/goods/after-detail", {params});
},
// 售后订单退款
afterAccept(params){
    return axios.get("/admin/order/goods/after-accept", {params});
},
// 售后订单重新提交
orderManagementReset(params){
    return axios.get("/admin/order/goods/after-reset", {params});
},

    // 获取省市区列表
    freightCityList(params) {
        return axios.get("/admin/freight/city/list", {params});
    },
    // 运费模板列表
    freightList(params) {
        return axios.get("/admin/freight/list", {params});
    },
    // 运费模板新增
    freightEdit(data) {
        return axios.post("/admin/freight/edit", data);
    },
    // 优惠券管理
    couponList(params){
        return axios.get("/admin/coupon/list", {params});
    },
    // 更新优惠券状态
    updateCoupon(params){
        return axios.get("/admin/coupon/update/status", {params});
    },
    // 优惠券详情
    couponDetail(params){
        return axios.get("/admin/coupon/detail", {params});
    },
     // 新增修改优惠券
     addCoupon(data) {
        return axios.post("/admin/coupon/edit", data);
    },
}

export default order;


// WEBPACK FOOTER //
// ./src/api/order.js